module.exports = __webpack_public_path__ + "static/media/smily-talks.f7f2ab1f.png";